import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

export const useStyles = makeStyles(({
  breakpoints, palette, fontSizes, lineHeights, fontWeights,
}: Theme) => ({
  main: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '1rem',
    padding: '1.5rem 1rem',
    [breakpoints.up('sm')]: {
      padding: '4rem 1rem',
      gap: '1.25rem',
    },
  },
  title: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '0.125rem',
    margin: 0,
    color: palette.custom.titleBlue,
    fontFamily: '"Noto Sans", sans-serif',
    fontWeight: fontWeights.medium,
    fontSize: fontSizes.lg,
    lineHeight: lineHeights.xxl,
    [breakpoints.up('sm')]: {
      fontSize: fontSizes.xxl,
      lineHeight: lineHeights.xxxl,
    },
  },
  logo: {
    display: 'block',
    width: '5.3125rem',
    height: '1rem',
    [breakpoints.up('sm')]: {
      width: '7.9375rem',
      height: '1.5rem',
    },
  },
  previewButton: {
    display: 'block',
    border: `0.76px solid ${palette.common.white}`,
    background: 'transparent',
    '&&': {
      borderRadius: '1.25rem',
      width: '21.25rem',
      height: '25rem',
    },
    [breakpoints.up('sm')]: {
      border: `1px solid ${palette.common.white}`,
      '&&': {
        width: '28.125rem',
        height: '37.5rem',
      },
    },
  },
  preview: {
    display: 'block',
    objectFit: 'cover',
    borderRadius: 'inherit',
    '&&': {
      width: '100%',
      height: '100%',
    },
  },
  share: {
    width: '22.1875rem',
    height: '3rem',
    '&&': {
      background: palette.primary.dark,
      fontWeight: fontWeights.medium,
    },
  },
  veeva: {
    position: 'absolute',
    right: 0,
    bottom: 0,
    '& > div': {
      fontSize: '0.25rem',
    },
  },
}));